import { generatePath } from 'react-router-dom'
import {
  CHECKOUT_CONFIRM_ORDER,
  CHECKOUT_CUSTOMER_PENDINGS,
  CHECKOUT_REGISTER_PAYMENT,
  CHECKOUT_CANCEL_PAYMENT,
  CHECKOUT_REOPEN_ORDER,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestConfirmOrder = async (id) => {
  const path = generatePath(CHECKOUT_CONFIRM_ORDER, { id })

  return request.post(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestCustomerPendings = async (id) => {
  const path = generatePath(CHECKOUT_CUSTOMER_PENDINGS, { id })

  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestRegisterPayment = async (params) => (
  request.post(CHECKOUT_REGISTER_PAYMENT, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestCancelPayment = async (id) => {
  const path = generatePath(CHECKOUT_CANCEL_PAYMENT, { id })

  return request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestReopenOrder = async (id) => {
  const path = generatePath(CHECKOUT_REOPEN_ORDER, { id })

  return request.post(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
